import React from 'react';
import { AiOutlineSearch } from 'react-icons/ai';

import useToggle from 'hooks/useToggle';

import { container } from './SearchWidget.module.scss';
import { menuIconBtn, menuIcon } from 'styles/components/buttons.module.scss';

import SearchOverlay from './SearchOverlay';

const SearchWidget = () => {
  const { value, toggle } = useToggle();

  return (
    <div className={container}>
      <button
        data-testid="search-btn"
        onClick={toggle}
        className={menuIconBtn}
        aria-label="Αναζήτησε κοσμήματα, δαχτυλίδια, κολιέ, βραχιόλια, ρολόγια, αξεσουάρ"
      >
        <AiOutlineSearch className={menuIcon} />
      </button>
      <SearchOverlay isOpen={value} close={toggle} />
    </div>
  );
};

export default SearchWidget;
